import { Icon } from '@aqarmap/aqarmap-ui';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { useFullRoutes } from '~/hooks';
import { useGetUserProfileQuery } from '~/redux/api/authApiSlice';

const UserEmail = () => {
  const { t } = useTranslation('app');
  const { data: userProfile } = useGetUserProfileQuery();
  const { MY_ACCOUNT_URL } = useFullRoutes();
  const hasPassword = userProfile?.has_password;
  const hasEmail = userProfile?.email;

  return (
    <div className="border-b border-gray py-2x px-3x flex">
      <div className="flex flex-col gap-x flex-1">
        <p className="text-title_4">{t('email')}</p>
        <p className="text-body_1 text-gray__dark_1">{userProfile?.email}</p>
      </div>
      {hasPassword ? (
        <Link to={MY_ACCOUNT_URL.UPDATE_EMAIL}>
          <Icon
            name={hasEmail ? 'edit' : 'plus'}
            className={hasPassword ? 'text-blue' : 'text-gray'}
          />
        </Link>
      ) : (
        <Icon
          name={hasEmail ? 'edit' : 'plus'}
          className={hasPassword ? 'text-blue' : 'text-gray'}
        />
      )}
    </div>
  );
};

export default UserEmail;
